import React from 'react'
import { useCheckoutSuccess, Styled } from 'lib/modules/checkout'
import { Container as SuccessContainer } from './styled'

export const SuccessScene = () => {
  const { orderId } = useCheckoutSuccess()

  return (
    <>
      <Styled.Container>
        <h1>
          Thank you!
        </h1>
        <Styled.CheckoutLayout>
          <SuccessContainer>
            <p>
              Your order<strong>{orderId ? ` #${orderId}` : ''}</strong> has been placed successfully!
            </p>
            <p>
              A confirmation email has been sent to your inbox.
            </p>
          </SuccessContainer>
        </Styled.CheckoutLayout>
      </Styled.Container>
    </>
  )
}
